import { Icon12Add, Icon12ArrowRight, Icon12ChevronRight, Icon12ChevronUp, Icon12Dropdown, Icon12ErrorCircleFillGray, Icon12Pin, Icon12QuoteClosing, Icon12Star, Icon12View, Icon16Add, Icon16ArrowLeftOutline, Icon16ArrowRightOutline, Icon16ArrowTriangleDown, Icon16ArrowTriangleUp, Icon16ArrowUpCircle, Icon16ArrowUturnLeftOutline, Icon16ArrowbranchOutline, Icon16Attach, Icon16Block, Icon16Bookmark, Icon16BookmarkOutline, Icon16BuildingOutline, Icon16CalendarOutline, Icon16Cancel, Icon16ChainOutline, Icon16CheckCircle, Icon16CheckCircleLarge, Icon16CheckOutline, Icon16Chevron, Icon16ChevronLeft, Icon16ClockCircleFill, Icon16Comment, Icon16CommentOutline, Icon16CrossCircleSmall, Icon16Dash, Icon16DeleteOutline, Icon16Done, Icon16DoneCircle, Icon16DoorEnterArrowRightOutline, Icon16DownloadOutline, Icon16Dropdown, Icon16DropdownFlipped, Icon16DropdownFlippedOutline, Icon16DropdownOutline, Icon16ErrorCircleOutline, Icon16Favorite, Icon16FavoriteOutline, Icon16FireAlt, Icon16GlobeOutline, Icon16GridOfFour, Icon16HelpOutline, Icon16HideOutline, Icon16LikeOutline, Icon16LinkOutline, Icon16Linked, Icon16LockOutline, Icon16MailOutline, Icon16MoreHorizontal, Icon16MoreVertical, Icon16Pen, Icon16PenOutline, Icon16Phone, Icon16PhoneOutline, Icon16PictureOutline, Icon16Pin, Icon16PinOutline, Icon16Poll, Icon16PopUpStickerOutline, Icon16RefreshOutline, Icon16ReplyOutline, Icon16RepostOutline, Icon16Search, Icon16SearchOutline, Icon16StarAlt, Icon16TextBoldOutline, Icon16TextItalicOutline, Icon16TextStrikethroughOutline, Icon16TextUnderlineOutline, Icon16TextViewfinderOutline, Icon16User, Icon16UserCircleAltOutline, Icon16Users, Icon16Users2Outline, Icon16VideoSquareOutline, Icon16View, Icon16ViewOutline, Icon20Add, Icon20AdvertisingOutline, Icon20AlarmOutline, Icon20ArrowUpOutline, Icon20ArrowUpRightOutline, Icon20ArrowUturnLeftOutline, Icon20ArticleBoxOutline, Icon20ArticleOutline, Icon20Attach, Icon20BookSpreadOutline, Icon20Bookmark, Icon20BookmarkOutline, Icon20BuildingOutline, Icon20CakeOutline, Icon20CalendarCheckOutline, Icon20CalendarOutline, Icon20Cancel, Icon20Chain, Icon20Check, Icon20CheckBoxIndetermanate, Icon20CheckCircleOn, Icon20CheckCircleOutline, Icon20CheckSquareOutline, Icon20ChecksSmallOutline, Icon20ChevronLeft2, Icon20ChevronRight, Icon20ChevronRight2, Icon20ChevronRightOutline, Icon20ChevronUp, Icon20ChevronUpOutline, Icon20CircleOutline, Icon20CircleSmall, Icon20CircleSmallFilled, Icon20CommentOutline, Icon20CopyOutline, Icon20CupOutline, Icon20DeleteOutline, Icon20DocumentOutline, Icon20DocumentTextOutline, Icon20DoorArrowRightOutline, Icon20DownloadOutline, Icon20Dropdown, Icon20EducationOutline, Icon20ErrorCircle, Icon20ErrorCircleOutline, Icon20FavoriteOutline, Icon20FlashOutline, Icon20FullscreenOutline, Icon20FunnelOutline, Icon20GearOutline, Icon20GlobeOutline, Icon20Grid4UnevenVerticalOutline, Icon20Hearts2Outline, Icon20HelpOutline, Icon20HomeOutline, Icon20IncognitoOutline, Icon20IndentDecreaseOutline, Icon20IndentIncreaseOutline, Icon20InfoCircleOutline, Icon20LightbulbOutline, Icon20LikeOutline, Icon20ListInsertFirstOutline, Icon20ListNumberOutline, Icon20LockOutline, Icon20LogoGeekbrainsOutline, Icon20LogoVkAdsOutline, Icon20MagnifierMinusOutline, Icon20MagnifierPlusOutline, Icon20MailOutline, Icon20MarkerOutline, Icon20MinusOutline, Icon20MoreHorizontal, Icon20NarrativeOutline, Icon20NotebookCheckOutline, Icon20PhoneOutline, Icon20PictureOutline, Icon20PictureSlashOutline, Icon20PictureStackOutline, Icon20PlaneOutline, Icon20PrinterOutline, Icon20Rectangle2HorizontalOutline, Icon20RectangleInfoOutline, Icon20RotateLeft, Icon20SlidersOutline, Icon20SmileOutline, Icon20SortOutline, Icon20Square4Outline, Icon20StarsFilled, Icon20TableHeaderOutline, Icon20TextCenterOutline, Icon20TextRightOutline, Icon20ThermometerOutline, Icon20UserCheckOutline, Icon20UserCircleOutline, Icon20UserOutline, Icon20UserSquareOnSquareOutline, Icon20UserSquareOutline, Icon20UserStarBadgeOutline, Icon20UserStarOutline, Icon20Users3Outline, Icon20UsersOutline, Icon20VideoSquareOutline, Icon20ViewOutline, Icon20WalletOutline, Icon20Write, Icon24Add, Icon24AddOutline, Icon24Advertising, Icon24AdvertisingOutline, Icon24Attach, Icon24Block, Icon24Bookmark, Icon24BookmarkOutline, Icon24BooksOutline, Icon24BriefcaseOutline, Icon24BuildingOutline, Icon24CalendarAddOutline, Icon24CalendarOutline, Icon24Cancel, Icon24CancelOutline, Icon24Cards2Outline, Icon24ChainOutline, Icon24CheckBoxOff, Icon24CheckBoxOn, Icon24CheckCircleOn, Icon24ChevronDown, Icon24ChevronDownSmall, Icon24ChevronLeftOutline, Icon24ChevronLeftSmallOutline, Icon24ChevronRightOutline, Icon24ChevronRightSmallOutline, Icon24ChevronUp, Icon24ChevronUpSmall, Icon24Clock, Icon24CommentAlt, Icon24ComputerSmartphoneOutline, Icon24CopyOutline, Icon24CupOutline, Icon24Delete, Icon24DeleteOutline, Icon24DismissOverlay, Icon24DismissSubstract, Icon24Document, Icon24DocumentOutline, Icon24DocumentStatsOutline, Icon24DocumentTextOutline, Icon24Done, Icon24DotsVertical, Icon24DownloadOutline, Icon24Dropdown, Icon24EducationOutline, Icon24ErrorCircleFillGray, Icon24ErrorCircleOutline, Icon24ExternalLinkOutline, Icon24Filter, Icon24FlagStart, Icon24FlapperOutline, Icon24Flash, Icon24FlashOutline, Icon24FolderOutline, Icon24FolderSimpleOutline, Icon24FolderSimpleUserOutline, Icon24GlobeOutline, Icon24Help, Icon24HelpOutline, Icon24Hide, Icon24IncognitoOutline, Icon24InfoCircleOutline, Icon24LikeOutline, Icon24Linked, Icon24ListBulletOutline, Icon24ListBulletSquareOutline, Icon24LogoVkColor, Icon24MenuOutline, Icon24MinusOutline, Icon24MoreHorizontal, Icon24MoreVertical, Icon24NarrativeOutline, Icon24NotificationOutline, Icon24NotificationSubtractOutline, Icon24PhotosStackOutline, Icon24PictureOutline, Icon24PlaceOutline, Icon24PlaneOutline, Icon24PrinterOutline, Icon24RadioOff, Icon24RadioOn, Icon24Refresh, Icon24RefreshOutline, Icon24RepeatOutline, Icon24Search, Icon24SendOutline, Icon24ServicesOutline, Icon24Square4PlusOutline, Icon24StarsOutline, Icon24User, Icon24UserOutline, Icon24Users3Outline, Icon24UsersOutline, Icon24View, Icon24WalletOutline, Icon28CancelCircleOutline, Icon28CheckCircleOutline, Icon28ChevronDownOutline, Icon28ChevronLeftOutline, Icon28ChevronRightOutline, Icon28CrossLargeOutline, Icon28ErrorOutline, Icon28FullscreenOutline, Icon28HandHeartOutline, Icon28HappyFaceOutline, Icon28HeartCircleOutline, Icon28InfoCircle, Icon28ListOutline, Icon28Rectangle2Outline, Icon28RotateLeftOutline, Icon28TablecellsOutline, Icon28TextLeftOutline } from "@vkontakte/icons";
const vkIconsMap = {
    favorite: {
        16: Icon16Favorite
    },
    favorite_outline: {
        16: Icon16FavoriteOutline,
        20: Icon20FavoriteOutline
    },
    error_circle_outline: {
        16: Icon16ErrorCircleOutline,
        20: Icon20ErrorCircleOutline,
        24: Icon24ErrorCircleOutline
    },
    add_outline: {
        24: Icon24AddOutline
    },
    help_outline: {
        16: Icon16HelpOutline,
        20: Icon20HelpOutline,
        24: Icon24HelpOutline
    },
    arrow_uturn_left_outline: {
        16: Icon16ArrowUturnLeftOutline,
        20: Icon20ArrowUturnLeftOutline
    },
    repost_outline: {
        16: Icon16RepostOutline
    },
    chevron_right_small_outline: {
        24: Icon24ChevronRightSmallOutline
    },
    cross_large_outline: {
        28: Icon28CrossLargeOutline
    },
    tablecells_outline: {
        28: Icon28TablecellsOutline
    },
    calendar_outline: {
        16: Icon16CalendarOutline,
        20: Icon20CalendarOutline,
        24: Icon24CalendarOutline
    },
    chevron_down: {
        24: Icon24ChevronDown
    },
    more_vertical: {
        16: Icon16MoreVertical,
        24: Icon24MoreVertical
    },
    write: {
        20: Icon20Write
    },
    arrow_up_circle: {
        16: Icon16ArrowUpCircle
    },
    view: {
        12: Icon12View,
        16: Icon16View,
        24: Icon24View
    },
    cross_circle_small: {
        16: Icon16CrossCircleSmall
    },
    arrow_right: {
        12: Icon12ArrowRight
    },
    dismiss_overlay: {
        24: Icon24DismissOverlay
    },
    dots_vertical: {
        24: Icon24DotsVertical
    },
    pen_outline: {
        16: Icon16PenOutline
    },
    delete_outline: {
        16: Icon16DeleteOutline,
        20: Icon20DeleteOutline,
        24: Icon24DeleteOutline
    },
    add: {
        12: Icon12Add,
        16: Icon16Add,
        20: Icon20Add,
        24: Icon24Add
    },
    circle_small_filled: {
        20: Icon20CircleSmallFilled
    },
    copy_outline: {
        20: Icon20CopyOutline,
        24: Icon24CopyOutline
    },
    users_2_outline: {
        16: Icon16Users2Outline
    },
    chevron: {
        16: Icon16Chevron
    },
    attach: {
        16: Icon16Attach,
        20: Icon20Attach,
        24: Icon24Attach
    },
    info_circle_outline: {
        20: Icon20InfoCircleOutline,
        24: Icon24InfoCircleOutline
    },
    lock_outline: {
        16: Icon16LockOutline,
        20: Icon20LockOutline
    },
    document: {
        24: Icon24Document
    },
    download_outline: {
        16: Icon16DownloadOutline,
        20: Icon20DownloadOutline,
        24: Icon24DownloadOutline
    },
    chevron_up_small: {
        24: Icon24ChevronUpSmall
    },
    chevron_down_small: {
        24: Icon24ChevronDownSmall
    },
    done: {
        16: Icon16Done,
        24: Icon24Done
    },
    incognito_outline: {
        20: Icon20IncognitoOutline,
        24: Icon24IncognitoOutline
    },
    users_outline: {
        20: Icon20UsersOutline,
        24: Icon24UsersOutline
    },
    building_outline: {
        16: Icon16BuildingOutline,
        20: Icon20BuildingOutline,
        24: Icon24BuildingOutline
    },
    view_outline: {
        16: Icon16ViewOutline,
        20: Icon20ViewOutline
    },
    hide_outline: {
        16: Icon16HideOutline
    },
    star_alt: {
        16: Icon16StarAlt
    },
    refresh: {
        24: Icon24Refresh
    },
    circle_small: {
        20: Icon20CircleSmall
    },
    done_circle: {
        16: Icon16DoneCircle
    },
    poll: {
        16: Icon16Poll
    },
    check_circle_large: {
        16: Icon16CheckCircleLarge
    },
    pen: {
        16: Icon16Pen
    },
    picture_outline: {
        16: Icon16PictureOutline,
        20: Icon20PictureOutline,
        24: Icon24PictureOutline
    },
    arrow_triangle_up: {
        16: Icon16ArrowTriangleUp
    },
    arrow_triangle_down: {
        16: Icon16ArrowTriangleDown
    },
    user: {
        16: Icon16User,
        24: Icon24User
    },
    block: {
        16: Icon16Block,
        24: Icon24Block
    },
    search_outline: {
        16: Icon16SearchOutline
    },
    cancel: {
        16: Icon16Cancel,
        20: Icon20Cancel,
        24: Icon24Cancel
    },
    arrowbranch_outline: {
        16: Icon16ArrowbranchOutline
    },
    dropdown_flipped_outline: {
        16: Icon16DropdownFlippedOutline
    },
    dropdown_outline: {
        16: Icon16DropdownOutline
    },
    flash_outline: {
        20: Icon20FlashOutline,
        24: Icon24FlashOutline
    },
    cards_2_outline: {
        24: Icon24Cards2Outline
    },
    document_outline: {
        20: Icon20DocumentOutline,
        24: Icon24DocumentOutline
    },
    list_bullet_outline: {
        24: Icon24ListBulletOutline
    },
    list_bullet_square_outline: {
        24: Icon24ListBulletSquareOutline
    },
    phone: {
        16: Icon16Phone
    },
    mail_outline: {
        16: Icon16MailOutline,
        20: Icon20MailOutline
    },
    user_circle_outline: {
        20: Icon20UserCircleOutline
    },
    pin: {
        12: Icon12Pin,
        16: Icon16Pin
    },
    pin_outline: {
        16: Icon16PinOutline
    },
    advertising: {
        24: Icon24Advertising
    },
    chevron_down_outline: {
        28: Icon28ChevronDownOutline
    },
    chevron_up_outline: {
        20: Icon20ChevronUpOutline
    },
    dropdown_flipped: {
        16: Icon16DropdownFlipped
    },
    dropdown: {
        12: Icon12Dropdown,
        16: Icon16Dropdown,
        20: Icon20Dropdown,
        24: Icon24Dropdown
    },
    pop_up_sticker_outline: {
        16: Icon16PopUpStickerOutline
    },
    home_outline: {
        20: Icon20HomeOutline
    },
    advertising_outline: {
        20: Icon20AdvertisingOutline,
        24: Icon24AdvertisingOutline
    },
    grid_4_uneven_vertical_outline: {
        20: Icon20Grid4UnevenVerticalOutline
    },
    rectangle_2_horizontal_outline: {
        20: Icon20Rectangle2HorizontalOutline
    },
    narrative_outline: {
        20: Icon20NarrativeOutline,
        24: Icon24NarrativeOutline
    },
    globe_outline: {
        16: Icon16GlobeOutline,
        20: Icon20GlobeOutline,
        24: Icon24GlobeOutline
    },
    bookmark_outline: {
        16: Icon16BookmarkOutline,
        20: Icon20BookmarkOutline,
        24: Icon24BookmarkOutline
    },
    article_box_outline: {
        20: Icon20ArticleBoxOutline
    },
    users_3_outline: {
        20: Icon20Users3Outline,
        24: Icon24Users3Outline
    },
    user_square_on_square_outline: {
        20: Icon20UserSquareOnSquareOutline
    },
    user_square_outline: {
        20: Icon20UserSquareOutline
    },
    wallet_outline: {
        20: Icon20WalletOutline,
        24: Icon24WalletOutline
    },
    user_check_outline: {
        20: Icon20UserCheckOutline
    },
    gear_outline: {
        20: Icon20GearOutline
    },
    hand_heart_outline: {
        28: Icon28HandHeartOutline
    },
    logo_vk_ads_outline: {
        20: Icon20LogoVkAdsOutline
    },
    plane_outline: {
        20: Icon20PlaneOutline,
        24: Icon24PlaneOutline
    },
    cup_outline: {
        20: Icon20CupOutline,
        24: Icon24CupOutline
    },
    briefcase_outline: {
        24: Icon24BriefcaseOutline
    },
    user_outline: {
        20: Icon20UserOutline,
        24: Icon24UserOutline
    },
    hearts_2_outline: {
        20: Icon20Hearts2Outline
    },
    notebook_check_outline: {
        20: Icon20NotebookCheckOutline
    },
    video_square_outline: {
        16: Icon16VideoSquareOutline,
        20: Icon20VideoSquareOutline
    },
    rectangle_info_outline: {
        20: Icon20RectangleInfoOutline
    },
    education_outline: {
        20: Icon20EducationOutline,
        24: Icon24EducationOutline
    },
    lightbulb_outline: {
        20: Icon20LightbulbOutline
    },
    thermometer_outline: {
        20: Icon20ThermometerOutline
    },
    chain: {
        20: Icon20Chain
    },
    phone_outline: {
        16: Icon16PhoneOutline,
        20: Icon20PhoneOutline
    },
    book_spread_outline: {
        20: Icon20BookSpreadOutline
    },
    calendar_check_outline: {
        20: Icon20CalendarCheckOutline
    },
    comment: {
        16: Icon16Comment
    },
    like_outline: {
        16: Icon16LikeOutline,
        20: Icon20LikeOutline,
        24: Icon24LikeOutline
    },
    check_circle_outline: {
        20: Icon20CheckCircleOutline,
        28: Icon28CheckCircleOutline
    },
    check_square_outline: {
        20: Icon20CheckSquareOutline
    },
    article_outline: {
        20: Icon20ArticleOutline
    },
    happy_face_outline: {
        28: Icon28HappyFaceOutline
    },
    alarm_outline: {
        20: Icon20AlarmOutline
    },
    chevron_up: {
        12: Icon12ChevronUp,
        20: Icon20ChevronUp,
        24: Icon24ChevronUp
    },
    check_circle_on: {
        20: Icon20CheckCircleOn,
        24: Icon24CheckCircleOn
    },
    printer_outline: {
        20: Icon20PrinterOutline,
        24: Icon24PrinterOutline
    },
    filter: {
        24: Icon24Filter
    },
    grid_of_four: {
        16: Icon16GridOfFour
    },
    door_enter_arrow_right_outline: {
        16: Icon16DoorEnterArrowRightOutline
    },
    chevron_left_2: {
        20: Icon20ChevronLeft2
    },
    chevron_right_2: {
        20: Icon20ChevronRight2
    },
    chevron_right: {
        12: Icon12ChevronRight,
        20: Icon20ChevronRight
    },
    menu_outline: {
        24: Icon24MenuOutline
    },
    comment_alt: {
        24: Icon24CommentAlt
    },
    dismiss_substract: {
        24: Icon24DismissSubstract
    },
    cancel_outline: {
        24: Icon24CancelOutline
    },
    refresh_outline: {
        16: Icon16RefreshOutline,
        24: Icon24RefreshOutline
    },
    link_outline: {
        16: Icon16LinkOutline
    },
    logo_vk_color: {
        24: Icon24LogoVkColor
    },
    services_outline: {
        24: Icon24ServicesOutline
    },
    comment_outline: {
        16: Icon16CommentOutline,
        20: Icon20CommentOutline
    },
    smile_outline: {
        20: Icon20SmileOutline
    },
    bookmark: {
        16: Icon16Bookmark,
        20: Icon20Bookmark,
        24: Icon24Bookmark
    },
    funnel_outline: {
        20: Icon20FunnelOutline
    },
    users: {
        16: Icon16Users
    },
    list_insert_first_outline: {
        20: Icon20ListInsertFirstOutline
    },
    error_outline: {
        28: Icon28ErrorOutline
    },
    dash: {
        16: Icon16Dash
    },
    check: {
        20: Icon20Check
    },
    check_circle: {
        16: Icon16CheckCircle
    },
    document_text_outline: {
        20: Icon20DocumentTextOutline,
        24: Icon24DocumentTextOutline
    },
    chain_outline: {
        16: Icon16ChainOutline,
        24: Icon24ChainOutline
    },
    computer_smartphone_outline: {
        24: Icon24ComputerSmartphoneOutline
    },
    user_star_outline: {
        20: Icon20UserStarOutline
    },
    external_link_outline: {
        24: Icon24ExternalLinkOutline
    },
    cake_outline: {
        20: Icon20CakeOutline
    },
    square_4_plus_outline: {
        24: Icon24Square4PlusOutline
    },
    delete: {
        24: Icon24Delete
    },
    user_circle_alt_outline: {
        16: Icon16UserCircleAltOutline
    },
    arrow_left_outline: {
        16: Icon16ArrowLeftOutline
    },
    error_circle_fill_gray: {
        12: Icon12ErrorCircleFillGray,
        24: Icon24ErrorCircleFillGray
    },
    door_arrow_right_outline: {
        20: Icon20DoorArrowRightOutline
    },
    search: {
        16: Icon16Search,
        24: Icon24Search
    },
    user_star_badge_outline: {
        20: Icon20UserStarBadgeOutline
    },
    linked: {
        16: Icon16Linked,
        24: Icon24Linked
    },
    reply_outline: {
        16: Icon16ReplyOutline
    },
    help: {
        24: Icon24Help
    },
    cancel_circle_outline: {
        28: Icon28CancelCircleOutline
    },
    sort_outline: {
        20: Icon20SortOutline
    },
    notification_subtract_outline: {
        24: Icon24NotificationSubtractOutline
    },
    notification_outline: {
        24: Icon24NotificationOutline
    },
    rectangle_2_outline: {
        28: Icon28Rectangle2Outline
    },
    chevron_left: {
        16: Icon16ChevronLeft
    },
    calendar_add_outline: {
        24: Icon24CalendarAddOutline
    },
    send_outline: {
        24: Icon24SendOutline
    },
    text_viewfinder_outline: {
        16: Icon16TextViewfinderOutline
    },
    picture_stack_outline: {
        20: Icon20PictureStackOutline
    },
    chevron_left_small_outline: {
        24: Icon24ChevronLeftSmallOutline
    },
    list_outline: {
        28: Icon28ListOutline
    },
    list_number_outline: {
        20: Icon20ListNumberOutline
    },
    indent_decrease_outline: {
        20: Icon20IndentDecreaseOutline
    },
    indent_increase_outline: {
        20: Icon20IndentIncreaseOutline
    },
    text_left_outline: {
        28: Icon28TextLeftOutline
    },
    text_center_outline: {
        20: Icon20TextCenterOutline
    },
    text_right_outline: {
        20: Icon20TextRightOutline
    },
    table_header_outline: {
        20: Icon20TableHeaderOutline
    },
    quote_closing: {
        12: Icon12QuoteClosing
    },
    text_bold_outline: {
        16: Icon16TextBoldOutline
    },
    text_italic_outline: {
        16: Icon16TextItalicOutline
    },
    text_underline_outline: {
        16: Icon16TextUnderlineOutline
    },
    text_strikethrough_outline: {
        16: Icon16TextStrikethroughOutline
    },
    marker_outline: {
        20: Icon20MarkerOutline
    },
    hide: {
        24: Icon24Hide
    },
    more_horizontal: {
        16: Icon16MoreHorizontal,
        20: Icon20MoreHorizontal,
        24: Icon24MoreHorizontal
    },
    square_4_outline: {
        20: Icon20Square4Outline
    },
    stars_outline: {
        24: Icon24StarsOutline
    },
    star: {
        12: Icon12Star
    },
    radio_off: {
        24: Icon24RadioOff
    },
    radio_on: {
        24: Icon24RadioOn
    },
    rotate_left: {
        20: Icon20RotateLeft
    },
    rotate_left_outline: {
        28: Icon28RotateLeftOutline
    },
    circle_outline: {
        20: Icon20CircleOutline
    },
    arrow_up_outline: {
        20: Icon20ArrowUpOutline
    },
    check_outline: {
        16: Icon16CheckOutline
    },
    fullscreen_outline: {
        20: Icon20FullscreenOutline,
        28: Icon28FullscreenOutline
    },
    chevron_right_outline: {
        20: Icon20ChevronRightOutline,
        24: Icon24ChevronRightOutline,
        28: Icon28ChevronRightOutline
    },
    heart_circle_outline: {
        28: Icon28HeartCircleOutline
    },
    picture_slash_outline: {
        20: Icon20PictureSlashOutline
    },
    chevron_left_outline: {
        24: Icon24ChevronLeftOutline,
        28: Icon28ChevronLeftOutline
    },
    minus_outline: {
        20: Icon20MinusOutline,
        24: Icon24MinusOutline
    },
    arrow_right_outline: {
        16: Icon16ArrowRightOutline
    },
    magnifier_minus_outline: {
        20: Icon20MagnifierMinusOutline
    },
    magnifier_plus_outline: {
        20: Icon20MagnifierPlusOutline
    },
    arrow_up_right_outline: {
        20: Icon20ArrowUpRightOutline
    },
    error_circle: {
        20: Icon20ErrorCircle
    },
    info_circle: {
        28: Icon28InfoCircle
    },
    check_box_off: {
        24: Icon24CheckBoxOff
    },
    check_box_on: {
        24: Icon24CheckBoxOn
    },
    check_box_indetermanate: {
        20: Icon20CheckBoxIndetermanate
    },
    checks_small_outline: {
        20: Icon20ChecksSmallOutline
    },
    clock_circle_fill: {
        16: Icon16ClockCircleFill
    },
    clock: {
        24: Icon24Clock
    },
    place_outline: {
        24: Icon24PlaceOutline
    },
    fire_alt: {
        16: Icon16FireAlt
    },
    flash: {
        24: Icon24Flash
    },
    flag_start: {
        24: Icon24FlagStart
    },
    stars_filled: {
        20: Icon20StarsFilled
    },
    logo_geekbrains_outline: {
        20: Icon20LogoGeekbrainsOutline
    },
    books_outline: {
        24: Icon24BooksOutline
    },
    photos_stack_outline: {
        24: Icon24PhotosStackOutline
    },
    folder_simple_outline: {
        24: Icon24FolderSimpleOutline
    },
    folder_simple_user_outline: {
        24: Icon24FolderSimpleUserOutline
    },
    document_stats_outline: {
        24: Icon24DocumentStatsOutline
    },
    repeat_outline: {
        24: Icon24RepeatOutline
    },
    folder_outline: {
        24: Icon24FolderOutline
    },
    flapper_outline: {
        24: Icon24FlapperOutline
    },
    sliders_outline: {
        20: Icon20SlidersOutline
    }
};
export { vkIconsMap };
